import { useQuery } from 'data-fetching-client';
import { GET_CONTACT_DETAILS } from '../data/queries';
import { captureException } from '../utils/captureException';
export const useGetContactDetails = (contactId, options = {}) => {
  const {
    data,
    loading,
    error,
    refetch
  } = useQuery(GET_CONTACT_DETAILS, Object.assign({}, options, {
    variables: {
      contactId
    },
    onError: err => {
      var _options$onError;
      captureException(err, ['useGetContactDetails']);
      (_options$onError = options.onError) === null || _options$onError === void 0 || _options$onError.call(options, err);
    }
  }));
  const refetchContactDetails = newContactId => {
    void refetch({
      contactId: newContactId
    });
  };
  return {
    loading,
    error,
    contactDetailsData: data === null || data === void 0 ? void 0 : data.contactDetails,
    refetchContactDetails
  };
};